module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('hotsite-dgc', [_c('div', {
    staticClass: "conteudo"
  }, [_c('bloco', {
    staticClass: "-nomargin -softpadding -fullheight"
  }, [_c('header', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('titulo', {
    staticClass: "-withbar -upper"
  }, [_vm._v("Sobre a DGC")])], 1), _c('div', {
    staticClass: "texto",
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('p', [_vm._v("A Diretoria de Contratos tem a finalidade de planejar,\nacompanhar a execução físico-financeira e coordenar a\nfiscalização administrativa dos contratos de obras e serviços de\nengenharia, cessão patrimonial e de serviços de natureza\ncontinuada, em consonância com as políticas e diretrizes de\ngovernança em contratações e aquisições regulamentadas pelo\nConselho de Administração da UFRN.")]), _c('p', [_vm._v("A Diretoria de Contratos é constituída por:")]), _c('ul', [_c('li', [_vm._v("Divisão de Formalização e Acompanhamento de Contratos")]), _c('li', [_vm._v("Divisão de Fiscalização de Contratos")])])]), _c('footer', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('back-and-share')], 1)])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-385084a4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/vue/pages/dgc/Sobre.vue
// module id = 478
// module chunks = 0